import '../../../js/core.js'
import 'sticky-kit/dist/sticky-kit'
import '../../../js/scroll-to-anchor.js'
import '../../../js/bottom-banner.js'
import '../../../js/sticky-sidebar.js'
import '../../../js/progress-bar.js'
import '../../../js/animation-on-scroll.js'
import '../../../js/contact-form.js'
import './single-make-an-analysis.less';

(function(){
  var url = window.location.href;

  $(".link-single a").each(function() {
      if(url == (this.href)) {
          $(this).closest("li").addClass("active");
      }
  });
})()

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{
        jQuery('.js-single-articles-carousel').owlCarousel({
          nav: true,
          loop: true,
          dots: true,
          margin: 24,
          items: 1,
          slideBy: 1
        });

    });
  })
});

$(function () {
  let Utils;
  (function (Utils) {
    var ToolTipShow = (function () {
      function ToolTipShow() {
        let _this = this;
        this.iconWidth = 22;
        this.init = function () {
          if ($(".tooltip-ref").length > 0) {
            $('.tooltip-ref').on('mouseover', _this.showToolTip);
            $('.tooltip-ref').on('mouseout', _this.hideToolTip);
            $('.close').on('click', _this.hideToolTip);
          }
        };
        this.resizeHandler = function () {
          clearTimeout(_this.resizeTimer);
          let that = _this;
          _this.resizeTimer = setTimeout(function () {
            that.PositionTooltipMessage();
          }, 200);
        };
        this.hideAllToolTips = function () {
          $(".message").attr("aria-hidden", "true").removeAttr('style');
          $(".tooltip-ref").attr("aria-expanded", "false");
          $(window).off("resize", _this.resizeHandler);
        };
        this.hideToolTip = function (eventArgs) {
          eventArgs.preventDefault();
          eventArgs.stopPropagation();
          $(eventArgs.target)
            .closest(".tooltip-ref").attr("aria-expanded", "false")
            .find(".message")
            .attr("aria-hidden", "true")
            .removeAttr('style');
          $(window).off("resize", _this.resizeHandler);
        };
        this.PositionTooltipMessage = function () {
          let tooltip = $(".tooltip-ref[aria-expanded='true']");
          let message = tooltip.find(".box");
          let windowWidth = $(window).innerWidth();
          let offset = message.offset();
          let position = message.position();
          let tooltipLeft = tooltip.offset().left;
          let arrow = tooltip.find(".arrow");
          message.removeAttr('style');
          arrow.removeAttr('style');
          arrow.css("left", tooltip.innerWidth() - _this.iconWidth);
          if (message.outerWidth() > windowWidth) {
            message.css("width", Math.round(windowWidth) - 4);
          }
          let left = tooltip.innerWidth() - (_this.iconWidth / 2) - (message.outerWidth() / 2);
          if (tooltipLeft + left <= 0) {
            left = -(offset.left - position.left) + 2;
          }
          if (tooltipLeft + left + message.outerWidth() > windowWidth) {
            left = (windowWidth - message.outerWidth()) - tooltipLeft;
          }
          message.css("left", Math.round(left));
          $(window).on("resize", _this.resizeHandler);
        };
        this.showToolTip = function (eventArgs) {
          eventArgs.preventDefault();
          eventArgs.stopPropagation();
          let tooltip = $(eventArgs.target).closest(".tooltip-ref");
          let message = tooltip.find(".message");
          _this.hideAllToolTips();
          message.attr("aria-hidden", "false");
          tooltip.attr("aria-expanded", "true");
          _this.PositionTooltipMessage();
        };
        this.init();
      }
      return ToolTipShow;
    }());
    Utils.ToolTipShow = ToolTipShow;
  })(Utils = Utils || (Utils = {}));

  $(document).ready(function () {
    new Utils.ToolTipShow();
  });
});
